export const STATUS_SELECT_OPTION = [
  { label: 'All', value: '' },
  { label: 'WAITING', value: 'WAITING' },
  { label: 'ACTIVATE', value: 'ACTIVATE' },
  { label: 'INACTIVATE', value: 'INACTIVATE' },
];
